import React from "react";
import ReactDOM from "react-dom";

const ConfirmationModal = ({ message, onConfirm, onCancel }) => {
  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onCancel} // Cancel if clicking outside the modal
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "12px",
          width: "90%",
          maxWidth: "350px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        }}
        onClick={(e) => e.stopPropagation()} // Prevent clicks inside modal from bubbling
      >
        <h3
          style={{
            marginTop: 0,
            marginBottom: "16px",
            fontSize: "18px",
            fontFamily: "'Inter', sans-serif",
            textAlign: "center",
          }}
        >
          {message}
        </h3>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              padding: "10px",
              border: "none",
              borderRadius: "8px",
              backgroundColor: "#e0e0e0",
              fontWeight: "bold",
              cursor: "pointer",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: "10px",
              border: "none",
              borderRadius: "8px",
              backgroundColor: "#ff6b6b",
              color: "white",
              fontWeight: "bold",
              cursor: "pointer",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            Clear All
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationModal;
